import React from 'react'
import Navbar from '../../components/navbar_poc'
import bg1 from '../../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'
import { casesData } from '../../data'

export default function PageCases() {
  return (
    <>
    <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Cases</h4>
                          <p className="text-muted mb-0">All business and startup cases are here,</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          {/* <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Case Study</Link></li> */}
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Case Studies</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="border-bottom pb-4">
              <div className="row">
                  <div className="col-lg-9 col-md-8">
                      <div className="section-title">
                          <h4 className="title mb-2">All Cases</h4>
                          <p className="text-muted mb-0">Most Relevance Cases</p>
                      </div>
                  </div>

                  <div className="col-lg-3 col-md-4 mt-4 mt-sm-0">
                      <div className="form custom-form">
                          <div className="mb-0">
                              <label className="form-label">Types of cases :</label>
                              <select className="form-select form-control" id="Sortbylist-cases">
                                  <option>All Cases</option>
                                  <option>Related</option>
                              </select>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="row">
            {casesData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                      <div className="cases border rounded position-relative overflow-hidden">
                          <Link to={`/page-case-single/${index}`}><img src={item.image} className="img-fluid" alt=""/></Link>
                          <div className="content p-4">
                              <h5><Link to={`/page-case-single/${index}`} className="title text-dark">{item.name}</Link></h5>
                              <small className="h6 text-muted mb-0">{item.title}</small>
                          </div>
                      </div>
                  </div>
              )
            })}

              {/* <div className="col-12 mt-4 pt-2">
                  <ul className="pagination justify-content-center mb-0 list-unstyled">
                      <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border"> Prev</Link></li>
                      <li className="active"><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">1</Link></li>
                      <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">2</Link></li>
                      <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">3</Link></li>
                      <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">4</Link></li>
                      <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">Next </Link></li>
                  </ul>
              </div> */}
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
